import { render, staticRenderFns } from "./RelatorioExportacaoLogAcoes.vue?vue&type=template&id=34b31b72"
import script from "./RelatorioExportacaoLogAcoes.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoLogAcoes.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacaoLogAcoes.vue?vue&type=style&index=0&id=34b31b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports